import { useEffect, useState } from 'react'

import type { User } from '@supabase/supabase-js'
import { getSupabase } from './supabaseClient'
import Login from './Login'
import ShoppingList from './ShoppingList'
import SignupForm from './SignupForm'
import { isDevelopment } from './util'
import LoadingPageSpinner from './LoadingPageSpinner'

const supabase = getSupabase()

export default function App() {
  const [user, setUser] = useState<User | null>(null)
  const [listId, setListId] = useState<string | null>(null)
  const [checkingAuth, setCheckingAuth] = useState(true)
  const [loadingList, setLoadingList] = useState(true)

  useEffect(() => {
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession()
      setUser(session?.user ?? null)
      setCheckingAuth(false)
    }

    getSession()

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user ?? null)
      }
    )

    return () => listener.subscription.unsubscribe()
  }, [])

  useEffect(() => {
    if (!user) {
      setLoadingList(false)
      return
    }

    setLoadingList(true)

    supabase
      .from('list_member')
      .select('list_id')
      .eq('email', user.email)
      .maybeSingle()
      .then(({ data }) => {
        setListId(data?.list_id ?? null)
        setLoadingList(false)
      })
  }, [user])

  // if (isDevelopment) {
  //   // return <SignupForm userMail={'a@b.se'}></SignupForm>
  //   // return <LoadingPageSpinner />
  //   return <Login></Login>
  //   // return <ShoppingList listGroupId={"ee9ad97e-b4b9-4137-ba65-7f00c30f8d55"} userMail={"ida@bergenholtz.se"} />
  // }

  if (checkingAuth || loadingList) return <LoadingPageSpinner />
  if (!user?.email) return <Login />
  if (!listId) return <SignupForm userMail={user.email} />

  return <ShoppingList listGroupId={listId} userMail={user.email} />
}
